import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import ModalCrop from "../Farmer/ModalCrop";

//import Alert
import { toast } from "react-toastify";

// Import module Services
import TambonService from "../../services/tambon.service";
import farmerService from "../../services/farmer.service";

//Import module for datePicker
import dayjs from "dayjs";
import { WatDatePicker } from "thaidatepicker-react";

//Import webCam
import Webcam from "./Webcam";

//Import Form
import { Form, Row, Col, FormControl } from "react-bootstrap";

//Import CSS
// import "./register.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const valid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0.75rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #ced4da",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
};

const invalid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0 0.375rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #dc3545",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  paddingRight: "calc(1.5em + 0.75rem)",
  backgroundImage:
    'url(\'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="%23dc3545"%3e%3ccircle cx="6" cy="6" r="4.5"/%3e%3cpath stroke-linejoin="round" d="M5.8 3.6h.4L6 6.5z"/%3e%3ccircle cx="6" cy="8.2" r=".6" fill="%23dc3545" stroke="none"/%3e%3c/svg%3e\')',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right calc(0.375em + 0.1875rem) center",
  backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)",
};

function Profile(props) {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [prov, setProv] = useState([]);
  const [amp, setAmp] = useState([]);
  const [tam, setTam] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [hiddenprename, setHiddenprename] = useState(true);
  const [hiddenCamera, setHiddenCamera] = useState(true);
  const [image, setImage] = useState({ preview: null, raw: null });
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState({});
  const [showCrop, setShowCrop] = useState(false);

  useEffect(() => {
    farmerService
      .getFarmerById(props.farmer_idcard)
      .then((res) => {
        if (res.data.success) {
          setForm((item) => {
            return { ...item, farmer_id: res.data.farmer.farmer_id };
          });
          setSelectedDate("clear");
          setSelectedDate(res.data.farmer.birth_date);
          const status = res.data.farmer.status ? "มีชีวิต" : "เสียชีวิต";
          let prename = "";
          let preother = "";
          let cwt = 0;
          let amp = 0;
          let tam = 0;
          if (
            res.data.farmer.pre_name == "นาย" ||
            res.data.farmer.pre_name == "นาง" ||
            res.data.farmer.pre_name == "น.ส."
          ) {
            prename = res.data.farmer.pre_name;
            setHiddenprename(true);
          } else {
            // setForm({
            //   ...form,
            //   ["pre_name"]: "อื่นๆ",
            //   ["pre_other"]: data.data.farmer.pre_name,
            // });
            prename = "อื่นๆ";
            preother = res.data.farmer.pre_name;
            setHiddenprename(false);
          }
          setImage({
            preview:
              process.env.REACT_APP_API +
              "/images/farmer/" +
              res.data.farmer.farmer_image,
          });

          TambonService.getByname({
            prov_name: res.data.farmer.prov_namt,
            amp_name: res.data.farmer.amp_namt,
            tam_name: res.data.farmer.tam_namt,
          }).then((response) => {
            cwt = response.data.data.cwt;
            amp = response.data.data.amp;
            tam = response.data.data.tambon;

            setAmp([
              {
                value: response.data.data.amp,
                label: response.data.data.amp_namt,
              },
            ]);
            setTam([
              {
                value: response.data.data.tambon,
                label: response.data.data.tam_namt,
              },
            ]);
            setForm({
              ...res.data.farmer,
              ["status"]: status,
              ["pre_name"]: prename,
              ["pre_other"]: preother,
              ["prov"]: cwt,
              ["amp"]: amp,
              ["tam"]: tam,
            });

            // setForm({
            //   ...form,
            //   ["amp"]: response.data.data.amp,
            //   ["tam"]: response.data.data.tambon,
            // });
          });

          // const new_prov = prov.filter(
          //   (o) => o.label == response.data.prov.replace("จังหวัด", "")
          // );
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        //err
        toast.error(err);
      });
  }, [props.farmer_idcard]);

  const findFormErrors = () => {
    const {
      id_card,
      pre_name,
      pre_other,
      first_name,
      last_name,
      prov,
      amp,
      tam,
      sex,
      birth_date,
    } = form;
    const newErrors = {};

    // check card error
    if (!id_card || id_card === "") newErrors.id_card = "กรุณากรอกบัตรประชาชน";
    // else if (usertype.length > 2) newErrors.usertype = "name is too long!";

    // prename errors
    if (!pre_name || pre_name === "0") {
      newErrors.pre_name = "กรุณาเลือกคำนำหน้า";
    } else if (pre_name === "อื่นๆ" && (pre_other === "" || !pre_other)) {
      newErrors.pre_other = "กรุณากรอกคำนำหน้า";
    }

    // firstname
    if (!first_name || first_name === "")
      newErrors.first_name = "กรุณากรอกชื่อ";

    // lastname
    if (!last_name || last_name === "") newErrors.last_name = "กรุณากรอกนาสกุล";

    // province
    if (!prov || prov === "") newErrors.prov = "กรุณาเลือกจังหวัด";

    // amphoe
    if (!amp || amp === "") newErrors.amp = "กรุณาเลือกอำเภอ";

    // tam
    if (!tam || tam === "") newErrors.tam = "กรุณาเลือกตำบล";

    // sex
    if (!sex || sex === "") newErrors.sex = "กรุณาเลือกตำบล";

    // birthday
    if (!birth_date || birth_date === "")
      newErrors.birth_date = "กรุณากรอกวันเกิด";

    return newErrors;
  };

  useEffect(() => {
    getProv();
  }, []);

  const getProv = () => {
    TambonService.get({ pro_id: "0", amp_id: "0", tam_id: "0" })
      .then((response) => {
        setProv(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching Prove: ", error);
      });
  };

  const urlImage = (e) => {
    setForm((newform) => ({
      ...newform,
      ["farmerProfileImg"]: e,
    }));
    setImage({
      preview: URL.createObjectURL(e),
    });
    setShowCrop(true);
  };

  // const initialForm = () => {
  //   setImage({
  //     preview: null,
  //   });
  //   setHiddenprename(true);
  //   setForm({
  //     id_card: "",
  //     pre_name: "",
  //     first_name: "",
  //     last_name: "",
  //     sex: "",
  //     tel: "",
  //     birth_date: "",
  //     address: "",
  //     prov: "",
  //   });
  //   setErrors({});
  //   setHiddenCamera(true);
  //   setSelectedDate("clear");
  //   setTimeout(() => {
  //     setSelectedDate("");
  //   }, 100);
  // };

  function checkID(id) {
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  }

  const getAmp = (prov) => {
    TambonService.get({
      pro_id: prov ? prov : 0,
      amp_id: 0,
      tam_id: 0,
    })
      .then((response) => {
        setAmp(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching amp: ", error);
      });
  };
  const getTam = (prov, amp) => {
    TambonService.get({
      pro_id: prov ? prov : 0,
      amp_id: amp ? amp : 0,
      tam_id: 0,
    })
      .then((response) => {
        setTam(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching tam: ", error);
      });
  };
  const handleWatDatePickerChange = (christDate, buddhistDate) => {
    console.log(buddhistDate);
    setSelectedDate(christDate);
    // Check click remove date
    if (christDate) {
      setForm({
        ...form,
        ["birth_date"]: christDate,
      });
    } else {
      setForm({
        ...form,
        ["birth_date"]: "",
      });
    }
    //Set error to Null
    setErrors({
      ...errors,
      ["birth_date"]: null,
    });
  };

  const setField = async (field, value) => {
    if (field.files) {
      setImage({
        preview: URL.createObjectURL(field.files[0]),
      });
      setForm({
        ...form,
        [field.name]: field.files[0],
      });
      setShowCrop(true);
    } else {
      if (field.name == "pre_name" && value == "อื่นๆ") {
        setHiddenprename(false);
      } else if (field.name == "pre_name" && value !== "อื่นๆ") {
        setHiddenprename(true);
      } else if (field.name == "id_card") {
        if (value.length != 13) {
          setErrors({ ...errors, [field.name]: "กรอกเลขบัตรไม่ครบ" });
        } else if (!checkID(value)) {
          setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
        } else {
          setErrors({ ...errors, [field.name]: null });
        }
      }
      await setForm({
        ...form,
        [field.name]: value,
      });
      if (errors[field.name] && field.name != "id_card")
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
  };
  const handleProvChange = async (prov) => {
    setErrors({
      ...errors,
      ["prov"]: null,
    });
    if (prov && prov != "") {
      await getAmp(prov);
      setForm({
        ...form,
        ["prov"]: prov,
        ["amp"]: "",
        ["tam"]: "",
      });
    } else {
      setAmp([]);
      setTam([]);
      setForm({
        ...form,
        ["prov"]: "",
        ["amp"]: "",
        ["tam"]: "",
      });
    }
  };
  const handleAmpChange = async (prov, amp) => {
    setErrors({
      ...errors,
      ["amp"]: null,
    });
    if (amp && amp != "") {
      await getTam(prov, amp);
      setForm({
        ...form,
        ["amp"]: amp,
        ["tam"]: "",
      });
    } else {
      setTam([]);
      setForm({
        ...form,
        ["tam"]: "",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    for (const key in form) {
      data.append(key, form[key]);
    }
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setLoading(true);
      farmerService
        .updateFarmerById(data)
        .then((response) => {
          if (response.data.success) {
            props.aftersubmit(response.data.data);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        })
        .finally(() => setLoading(false));
    }
  };

  const cropImage = (e) => {
    console.log(e);
    setForm((newform) => ({
      ...newform,
      ["farmerProfileImg"]: e.file,
    }));
    setImage({
      preview: e.preview,
    });
  };

  return (
    <div className="container" hidden={props.hidden}>
      <div className="row">
        <div className="col-md-6 offset-md-3">
          <h3 className="text-center">แก้ไขข้อมูล</h3>
          <ModalCrop
            show={showCrop}
            hidden={setShowCrop}
            image={image.preview}
            setCrop={cropImage}
          />
          <div className="uploadpic">
            <label htmlFor="upload-button">
              {image.preview ? (
                <img src={image.preview} alt="dummy" width="150" height="150" />
              ) : (
                <>
                  <span className="fa-7x mt-3 mb-2 upload-font">
                    <i className="bi bi-file-person" />
                  </span>
                  <h5 className="text-center">Upload your photo</h5>
                </>
              )}
            </label>
            <input
              type="file"
              id="upload-button"
              name="farmerProfileImg"
              style={{ display: "none" }}
              onChange={(e) => setField(e.target, e.target.value)}
            />
            <br />
            {/* <Button variant="primary" type="button" onClick={handleUpload}>
            อัพโหลด
          </Button> */}
          </div>
          <div style={{ textAlign: "center" }}>
            <br />
            {hiddenCamera ? "" : <Webcam urlImage={urlImage} />}
            <button
              className="btn btn-primary"
              onClick={() =>
                hiddenCamera ? setHiddenCamera(false) : setHiddenCamera(true)
              }
              style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
            >
              {hiddenCamera ? "เปิดกล้อง" : "ปิดกล้อง"}
            </button>
          </div>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>เลขบัตรประชาชน</Form.Label>
                  <FormControl
                    placeholder="เลขบัตรประชาชน"
                    type="number"
                    name="id_card"
                    value={form.id_card}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.id_card}
                    disabled={true}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.id_card}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>คำนำหน้า</Form.Label>
                  <Form.Select
                    name="pre_name"
                    value={form.pre_name}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.pre_name}
                  >
                    <option value="0">เลือก...</option>
                    <option value="นาย">นาย</option>
                    <option value="นาง">นาง</option>
                    <option value="น.ส.">น.ส.</option>
                    <option value="อื่นๆ">อื่นๆ</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.pre_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row hidden={hiddenprename}>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อื่นๆ </Form.Label>
                  <FormControl
                    placeholder="คำนำหน้าอื่น ๆ"
                    type="text"
                    name="pre_other"
                    value={form.pre_other}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.pre_other}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.pre_other}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6"></Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อ</Form.Label>
                  <FormControl
                    placeholder="ชื่อ"
                    type="text"
                    name="first_name"
                    value={form.first_name}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.first_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.first_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>นามสกุล</Form.Label>
                  <FormControl
                    placeholder="นามสกุล"
                    type="text"
                    name="last_name"
                    value={form.last_name}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.last_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.last_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>เพศ</Form.Label>
                  <Form.Select
                    name="sex"
                    value={form.sex}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.sex}
                  >
                    <option value="">เลือก...</option>
                    <option value="ชาย">ชาย</option>
                    <option value="หญิง">หญิง</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.sex}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>โทร.</Form.Label>
                  <FormControl
                    placeholder="โทร"
                    type="text"
                    name="tel"
                    value={form.tel}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.tel}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tel}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>{!!errors.birth_date}วันที่เกิด</Form.Label>

                  {selectedDate == "" || selectedDate != "clear" ? (
                    <WatDatePicker
                      placeholder="เลือกวันเกิด"
                      value={selectedDate} // Can be replace with string or dayjs object (e.g. "2020-12-31" or `dayjs()`)
                      onChange={handleWatDatePickerChange}
                      dateFormat={"yyyy-MM-dd"} // for set data purpose [using date-fns format](https://date-fns.org/v2.12.0/docs/format)
                      displayFormat={"DD MMMM YYYY"} // for display purpose (using dayjs format)[https://day.js.org/docs/en/display/format]
                      inputStyle={errors.birth_date ? invalid : valid} // styles for input
                      clearable={true} // true | false
                      // minDate={"2020-12-26"} // supported date as string
                      maxDate={dayjs().add(20, "day")} // also supported dayjs or moment
                      disabled={false} // true | false
                      readOnly={false} // true | false
                      yearBoundary={99} // number of boundary ±X Year
                    />
                  ) : (
                    ""
                  )}

                  <div
                    className={
                      errors.birth_date
                        ? "custom-valid-feedback"
                        : "custom-invalid-feedback"
                    }
                  >
                    {errors.birth_date}
                  </div>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ที่อยู่</Form.Label>
                  <FormControl
                    placeholder="ที่อยู่"
                    type="text"
                    name="address"
                    value={form.address}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.address}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.address}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>จังหวัด</Form.Label>
                  <Form.Select
                    name="prov"
                    value={form.prov}
                    onChange={(e) => handleProvChange(e.target.value)}
                    isInvalid={!!errors.prov}
                  >
                    <option value="">เลือกจังหวัด</option>
                    {prov.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.prov}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อำเภอ</Form.Label>
                  <Form.Select
                    name="amp"
                    value={form.amp || ""}
                    onChange={(e) => handleAmpChange(form.prov, e.target.value)}
                    isInvalid={!!errors.amp}
                  >
                    <option value="">เลือกอำเภอ</option>
                    {amp.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.amp}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ตำบล</Form.Label>
                  <Form.Select
                    name="tam"
                    value={form.tam || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.tam}
                  >
                    <option value="">เลือกตำบล</option>
                    {tam.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.tam}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col></Col>
            </Row>
          </Form>

          <br />
          <div className="btn-page-register text-center">
            <button className="btn btn-primary" onClick={() => props.toggle()}>
              ปิด
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              บันทึก
            </button>
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
}

export default Profile;

Profile.propTypes = {
  farmer_idcard: PropTypes.number,
  aftersubmit: PropTypes.func,
  hidden: PropTypes.bool,
  toggle: PropTypes.func,
};
